import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import React, { useState, useRef } from 'react';
import { getToDboStatus, makeToDbo } from '../api';
import CircularProgress from '@mui/material/CircularProgress';

const DboIssue = ({ applicationId, ClientData }) => {
    const history = useHistory();
    const [processing, setProcessing] = useState(false);
    const [started, setStarted] = useState(false); // нажата ли "Продолжить"
    const [message, setMessage] = useState("");
    const [timeoutReached, setTimeoutReached] = useState(false);
    const statusIntervalRef = useRef(null);
    const timeoutTimerRef = useRef(null);

    const fetchCurrentStatus = async () => {
        try {
            const response = await getToDboStatus(applicationId);
            const statusMessage = typeof response.data === 'string'
                ? response.data
                : JSON.stringify(response.data);
            setMessage(statusMessage);

            if (
                statusMessage.includes("завершено") ||
                statusMessage.includes("ошибка") ||
                statusMessage.includes("Оформление заявки возможно только через ДБО") ||
                statusMessage.includes("Оформление займа возможно только в ОФИСЕ")
            ) {
                clearInterval(statusIntervalRef.current);
                clearTimeout(timeoutTimerRef.current);
                setProcessing(false);
                setTimeoutReached(true);
            }
        } catch (error) {
            setMessage("Ошибка при получении статуса: " + (error?.message || "Неизвестная ошибка"));
        }
    };

    const handlerCancelDboIssue = () => {
        if (statusIntervalRef.current) clearInterval(statusIntervalRef.current);
        history.push("/");
    };

    const startStatusPolling = () => {
        if (timeoutTimerRef.current) clearTimeout(timeoutTimerRef.current);
        if (statusIntervalRef.current) clearInterval(statusIntervalRef.current);

        timeoutTimerRef.current = setTimeout(() => {
            setTimeoutReached(true);
            if (statusIntervalRef.current) clearInterval(statusIntervalRef.current);
            setProcessing(false);
            setMessage("Время ожидания истекло");
        }, 300000);

        fetchCurrentStatus();
        statusIntervalRef.current = setInterval(fetchCurrentStatus, 5000);
    };

    function transformToUpdateApplicationRequest(originalData) {
        const russia = 455;
        const client = {
            id: originalData.id || null,
            maidenName: originalData.client.maidenName || "",
            birthplace: originalData.client.birthplace || "",
            inn: originalData.client.inn || "",
            snils: "",
            sexId: originalData.client.sexId || 0,
            birthCountryId: russia,
            residenceCountryId: russia,
            citizenshipCountryId: russia,
            email: originalData.client.email || "",
            maritalStatusId: originalData.client.maritalStatusId || 0,
            childrenCount: 0,
            income: originalData.client.income || 0,
            monthlyCommitment: 0,
            addressMatches: originalData.client.addressMatches,
            actAddress: originalData.client.actAddress,
            regAddress: originalData.client.regAddress
        };
        return { client };
    }

    const handleStart = async () => {
        setStarted(true);
        setProcessing(true);
        setMessage("Инициализация ДБО...");

        try {
            const data = transformToUpdateApplicationRequest(ClientData);
            const response = await makeToDbo(applicationId, data);

            if (response === false) {
                throw new Error('API request failed');
            }

            setMessage("Инициализация ДБО завершена");
            startStatusPolling();
        } catch (error) {
            setMessage("Ошибка при инициализации ДБО: " + (error?.message || "Неизвестная ошибка"));
            setProcessing(false);
        }
    };

    return (
        <div className="rejection">
            {/* Стили прямо в компоненте */}
            <style>
                {`
                .agreements {
                  margin: 15px 0;
                }
                .checkboxes {
                  display: flex;
                  flex-direction: column;
                  gap: 8px;
                  margin-bottom: 15px;
                }
                .checkbox-label {
                  display: flex;
                  align-items: center;
                  font-size: 14px;
                }
                .continue-btn {
                  margin-top: 10px;
                  padding: 8px 16px;
                  background-color: rgb(254, 219, 49);
                  color: white;
                  border: none;
                  border-radius: 4px;
                  cursor: pointer;
                }
                .continue-btn:disabled {
                  background-color: #ccc;
                  cursor: not-allowed;
                }
                .progress-indicator {
                  display: flex;
                  align-items: center;
                  margin-top: 15px;
                }
                `}
            </style>

            <fieldset className="rejection-content">
                <Formik initialValues={{ sogl1: false, sogl2: false }}>
                    {({ values }) => (
                        <Form>
                            <div role="group" className="status-container">
                                <h3>Процесс оформления ДБО</h3>

                                {!started && (
                                    <div className="agreements">
                                        <p><strong>Требуется получить согласие клиента:</strong></p>
                                        <div className="checkboxes">
                                            <label className="checkbox-label">
                                                <Field type="checkbox" name="sogl1" />
                                                Согласие на запрос кредитной истории из БКИ
                                            </label>
                                            <label className="checkbox-label">
                                                <Field type="checkbox" name="sogl2" />
                                                Согласие на обработку персональных данных
                                            </label>
                                        </div>

                                        <button
                                            className="continue-btn"
                                            type="button"
                                            onClick={handleStart}
                                            disabled={!values.sogl1 || !values.sogl2}
                                        >
                                            Продолжить
                                        </button>
                                    </div>
                                )}

                                {started && (
                                    <div className="status-message">
                                        {processing ? (
                                            <div className="progress-indicator">
                                                <CircularProgress size={24} color="primary" />
                                                <span style={{ marginLeft: '10px' }}>{message}</span>
                                            </div>
                                        ) : (
                                            <div className="final-status">
                                                {timeoutReached ? (
                                                    <div className="timeout-message error">
                                                        {message}. Пожалуйста, попробуйте позже или обратитесь в поддержку.
                                                    </div>
                                                ) : (
                                                    <div className="completion-message">{message}</div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="action-buttons">
                                <button
                                    className="btn"
                                    type="button"
                                    onClick={handlerCancelDboIssue}
                                    disabled={processing}
                                >
                                    {processing ? 'Ожидание...' : 'Вернуться'}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </fieldset>
        </div>
    );
};

export default DboIssue;
